import { Controller } from "@hotwired/stimulus"

// Moves one flash message into the live region matching its severity, after
// that region is already in the document.
//
// The container carried aria-live="polite" and the toasts were server-rendered
// inside it, which announces nothing: a live region has to exist before content
// enters it, and content present at region-creation time is skipped by NVDA,
// JAWS and VoiceOver alike. Every flash message in the app was silent. Errors
// also shared the polite region with successes, so a failure queued behind a
// "Saved." to be read out.
//
// The controller is on the message rather than on the container because Turbo
// morphs the container: it survives a navigation, so its connect() fires once
// on the first page load — before any flash exists — and never again. A message
// element is new every time, so this fires every time.
export default class extends Controller {
  static values = { severity: { type: String, default: "notice" } }

  static REGIONS = { notice: "toast-status", alert: "toast-alert" }

  connect() {
    // A frame, so a region added in the same paint is observed before anything
    // is appended to it.
    this.frame = requestAnimationFrame(() => this.present())
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }

  present() {
    const region = document.getElementById(this.constructor.REGIONS[this.severityValue])
    if (!region) return

    region.append(this.element.content.cloneNode(true))
  }
}
